import React, { useRef, useState, useEffect, useCallback } from 'react';
import classes from '../Register/Register.module.css';
import fl_logo from '../../assets/fl_logo.png';
import { LockOpenOutlined } from '@material-ui/icons';
import CustomPasswordField from '../../ui/CustomPasswordField';
import CustomButton from '../../ui/CustomButton';
import CustomSpinner from '../../ui/CustomSpinner';
import useV3Axios from '../../hooks/useV3Axios';
import { useHistory, useLocation } from 'react-router-dom';
import { LOGIN_PATH } from '../../utils/paths';

const ResetPassword = () => {
    const history = useHistory();
    const location = useLocation();
    const params = new URLSearchParams(location.search);
    const id = params.get('id');
    const token = params.get('token');

    const passwordRef = useRef(null);
    const confirmRef = useRef(null);
    const [error, setError] = useState(null);
    const [success, setSuccess] = useState(false);

    const { isLoading, error: axiosError, data, sendRequest } = useV3Axios();

    useEffect(() => {
        if (!id || !token) history.replace(LOGIN_PATH);
    }, [id, token, history]);

    useEffect(() => {
        if (data) setSuccess(true);
    }, [data]);

    useEffect(() => {
        if (axiosError) setError(axiosError);
    }, [axiosError]);

    const handleSubmit = useCallback((event) => {
        event.preventDefault();
        setError(null);

        const pwd = passwordRef.current.value;
        const confirm = confirmRef.current.value;

        if (pwd !== confirm) {
            setError('Passwords do not match.');
            return;
        }

        const passwordPolicy = /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[\W_]).{8,}$/;
        if (!passwordPolicy.test(pwd)) {
            setError('Password must be at least 8 characters with uppercase, lowercase, digit, and special character.');
            return;
        }

        sendRequest('/auth/reset-password', { id, token, password: pwd });
    }, [sendRequest, id, token]);

    if (!id || !token) return null;

    return (
        <div className={classes.Login}>
            <div className={classes.Card}>
                <img className={classes.Logo} src={fl_logo} alt="logo" />
                <p className={classes.Title}>FetalLite Dashboard</p>
                {!success ? (
                    <form className={classes.Form} onSubmit={handleSubmit}>
                        <h3 style={{ textAlign: 'left', margin: '0 0 16px 0', color: '#333' }}>Set a new password</h3>
                        <CustomPasswordField reference={passwordRef} id='password' label='New password'>
                            <LockOpenOutlined />
                        </CustomPasswordField>
                        <div style={{ margin: '10px 0 0 0' }}>
                            <CustomPasswordField reference={confirmRef} id='confirmPassword' label='Confirm new password'>
                                <LockOpenOutlined />
                            </CustomPasswordField>
                        </div>
                        {error && <p className={classes.Error}>{error}</p>}
                        <div className={classes.Container}>
                            {isLoading ? <CustomSpinner /> : <CustomButton type='submit' size='large'>SET PASSWORD</CustomButton>}
                        </div>
                    </form>
                ) : (
                    <div className={classes.Form}>
                        <h3 style={{ textAlign: 'left', color: '#333' }}>Password updated</h3>
                        <p className={classes.Success}>Your password has been reset successfully.</p>
                        <div className={classes.Container}>
                            <CustomButton type='button' size='large' onClick={() => history.push(LOGIN_PATH)}>
                                GO TO SIGN IN
                            </CustomButton>
                        </div>
                    </div>
                )}
            </div>
        </div>
    );
};

export default ResetPassword;
